<template>
    <div>
        <main>
            <slot name="content"></slot>
            <main-footer v-if="showFooter"></main-footer>
        </main>
    </div>
</template>

<script>
    import Footer from '@/layout/Footer'

    export default {
        props: {
            showFooter: {default: true}
        },
        components: {
            'main-footer': Footer,
        },
    }

</script><style lang="scss">@import "@/assets/scss/layout/_main.scss";</style>